/**
 * Maps the public portal hostnames to their brand.
 *
 * `domain` is matched against `window.location.hostname` as an exact host or as
 * a parent of it, so sub-domain prefixes such as `www.` and staging hosts
 * resolve to the same brand as the bare domain.
 *
 * Any host that matches nothing here is treated as unbranded.
 */
export default Object.freeze([
    Object.freeze({ domain: 'portal.lawnswood.com.au', brand: 'Lawnswood' }),
    Object.freeze({ domain: 'portal.edenhills.com.au', brand: 'Edenhills' }),
    Object.freeze({ domain: 'portal.petsinpeace.com.au', brand: 'Pets in Peace' }),
    Object.freeze({ domain: 'portal.patchandpurr.com.au', brand: 'Patch & Purr' }),
    Object.freeze({ domain: 'portal.petsatpeacecw.com.au', brand: 'Pets at Peace CW' })
]);
